import { PageStepper } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { MESSAGES } from "./message-definitions";

export const OnboardingStepper = ({ currentStep }: { currentStep: number }) => {
  const intl = useIntl();

  const ONBOARDING_STEPS = [
    intl.formatMessage(MESSAGES.stepBusinessInformation),
    intl.formatMessage(MESSAGES.stepContactDetails),
    intl.formatMessage(MESSAGES.stepMonthlyRevenue),
    intl.formatMessage(MESSAGES.stepFundingDetails),
    intl.formatMessage(MESSAGES.stepConnectionsAndData),
    intl.formatMessage(MESSAGES.stepApplicationReview),
  ];

  return <PageStepper currentIndex={currentStep} steps={ONBOARDING_STEPS} maxVisibleSteps={ONBOARDING_STEPS.length} />;
};
